import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// Composant d'entrée téléphone : indicatif + numéro
const PhoneInput = ({ indicatif, setIndicatif, numero, setNumero, erreurTel, t }) => {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>

       {/* Sélecteur d’indicatif */}
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel>{t("CountryCode")}</InputLabel>
        <Select
          value={indicatif}
          onChange={(e) => setIndicatif(e.target.value)}
          label={t("CountryCode")}
        >
          {/* Liste des indicatifs disponibles */}
          <MenuItem value="+33">🇫🇷 +33</MenuItem>
          <MenuItem value="+32">🇧🇪 +32</MenuItem>
          <MenuItem value="+41">🇨🇭 +41</MenuItem>
          <MenuItem value="+34">🇪🇸 +34</MenuItem>
          <MenuItem value="+39">🇮🇹 +39</MenuItem>
          <MenuItem value="+49">🇩🇪 +49</MenuItem>
          <MenuItem value="+1">🇺🇸 +1</MenuItem>
          <MenuItem value="+44">🇬🇧 +44</MenuItem>
        </Select>
      </FormControl>

      {/* Champ numéro de téléphone */}
      <TextField
        label={t("PhoneNumber")}
        type="tel"
        fullWidth
        value={numero}
        onChange={(e) => setNumero(e.target.value)}
        error={!!erreurTel}
        helperText={erreurTel}
        sx={{ backgroundColor: "#fff", borderRadius: 1 }}
      />
    </Box>
  );
};

export default PhoneInput;
